module.exports = __webpack_public_path__ + "img/estrella.41100181.svg";